export default {
    SUCC: {code: 0, msg: 'success'},
    PARAM_INVALID: {code: 1001, msg: 'parameter invalid'}
};
